import dayjs from "dayjs";
import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { dateCommon } from "../helpers/common";
import { NhanVienResponse } from "../models/nhanvien/NhanVien";
import { CauHinhHanChotKPI, CauHinhHanChotKPIRequest, CauHinhHopDongFile, CauHinhLuong, CauHinhThue, HanChotKPIResponse, LanhDaoPhuTrachPhongRequest, NgayLamViec, NgayNghiInfo, Setting, SoHieuVanBan, SoHieuVanBanRequest } from "../models/setting/Setting";
import intance from "../utils/axios";

export const layThongTinCauHinh = async () => {
    var rs: Setting = {
        hostMail: "",
        portMail: 0,
        userNameMail: "",
        passwordMail: "",
        thoiHan: 0,
        sinhNhatQuy:0,
    };
    await intance.get(ApiPaths.setting.laytatca)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};
export const layTheoMaCauHinh = async (maCauHinh: string) => {
    var rs: string = "";
    await intance.get(ApiPaths.setting.layTheoMaCauHinh + "?ma=" + maCauHinh)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuCauHinh = async (request: Setting) => {
    let rs = false;
    await intance.post(ApiPaths.setting.luu, request)
        .then(res => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true
            }
        })
        .catch(err => {
            throw err;
        })
    return rs;
}

/// Lấy tệp mẫu Hợp đồng lao động đang được cấu hình, null nếu chưa cấu hình
export const layCauHinhHopDong = async (): Promise<CauHinhHopDongFile | null> => {
    var rs: CauHinhHopDongFile | null = null;
    await intance.get(ApiPaths.setting.layCauHinhHopDong)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

/// Tải lên tệp mẫu Hợp đồng lao động (.doc, .docx, .pdf)
export const luuCauHinhHopDong = async (file: any): Promise<CauHinhHopDongFile | null> => {
    var rs: CauHinhHopDongFile | null = null;
    const formData = new FormData();
    formData.append("file", file);

    await intance.post(ApiPaths.setting.luuCauHinhHopDong, formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then(res => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        })
    return rs;
}

export const layNgayNghiTrongTuan = async () => {
    var rs: number[] = [];
    await intance.get(ApiPaths.setting.layNgayNghiTrongTuan)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layDSNgayNghiLe = async () => {
    var rs: NgayNghiInfo[] = [];
    await intance.get(ApiPaths.setting.layTatCaDSCauHinhNgayNghi)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu.map((_item: any) => {
            return {
                ngayThang:dayjs(dateCommon.formatDate(_item.ngayThang), "DD/MM/YYYY"),
                lapHangNam: _item.lapHangNam || 0,
                idLoaiNgayNghi: _item.idLoaiNgayNghi
            }
        });
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layThongTinCauHinhNgayLamViec = async () => {
    var rs: NgayLamViec = {
        thuHai: 0,
        thuBa: 0,
        thuTu: 0,
        thuNam: 0,
        thuSau: 0,
        thuBay: 0,
        chuNhat: 0,
    };
    await intance.get(ApiPaths.setting.laytatca)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuCauHinhNgayLamViec = async (request: NgayLamViec) => {
    let rs = false;
    await intance.post(ApiPaths.setting.luuCauHinhNgayLamViec, request)
        .then(res => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true
            }
        })
        .catch(err => {
            throw err;
        })
    return rs;
}

export const layDanhSachPhoGiamDocPhuTrach = async () => {
    var rs: Array<NhanVienResponse> = [];
    await intance.get(ApiPaths.nhanVien.LayDsPhoGiamDocPhuTrach)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const luuLanhDaoPhuTrachPhong = async (request: LanhDaoPhuTrachPhongRequest) => {
    var rs = false;
    await intance.post(ApiPaths.setting.luuLanhDaoPhuTrachPhong, request)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true;
            }
        })
        .catch((error) => {
            throw error;
        })
    return rs;
};

export const layThongTinCauHinhLuong = async () => {
    var rs: CauHinhLuong = {
        congDoanMax: 0,
        heSo_LCB_NQL: 0,
        mucLuongDongBH_NQL: 0
    };
    await intance.get(ApiPaths.setting.laytatca)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuCauHinhLuong = async (request: CauHinhLuong) => {
    let rs = false;
    await intance.post(ApiPaths.setting.luuCauHinhLuong, request)
        .then(res => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true
            }
        })
        .catch(err => {
            throw err;
        })
    return rs;
}

export const layThongTinCauHinhThue = async (): Promise<CauHinhThue> => {
    var rs: CauHinhThue = {
        soTienToiThieuTinhThueKTX: 2000000
    };
    await intance.get(ApiPaths.setting.layCauHinhThue)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong && res.data.duLieu) {
                rs = res.data.duLieu;
            }
        })
        .catch((err) => {
            console.error(err);
        });
    return rs;
};

export const luuCauHinhThue = async (request: CauHinhThue) => {
    let rs = false;
    await intance.post(ApiPaths.setting.luuCauHinhThue, request)
        .then(res => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true;
            }
        })
        .catch(err => {
            throw err;
        });
    return rs;
};

export const layDSCauHinhHanChotKPI = async () => {
    var rs: Array<CauHinhHanChotKPI> = [];
    await intance.get(ApiPaths.setting.layDSCauHinhHanChotKPI)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu.map((_item: any) => {
                    return {
                        id: _item.id,
                        thangNam: _item.thangNam ? dayjs(_item.thangNam) : null,
                        laMacDinh: _item.laMacDinh,
                        ngayNhanVien: _item.ngayNhanVien,
                        ngayLanhDaoPhong: _item.ngayLanhDaoPhong,
                        ngayBanDieuHanh: _item.ngayBanDieuHanh,
                        ghiChu: _item.ghiChu || "",
                    }
                });
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuCauHinhHanChotKPI = async (request: CauHinhHanChotKPIRequest) => {
    await intance.post(ApiPaths.setting.luuCauHinhHanChotKPI, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

/// Kiểm tra hạn chót trình KPI thực tế của một tháng (thangNam định dạng MM/YYYY)
export const layHanChotTrinhKPI = async (thangNam: string) => {
    var rs: HanChotKPIResponse | null = null;
    await intance.get(ApiPaths.kpi.layHanChotTrinhKPI + "?thangNam=" + thangNam)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = {
                    thangNam: res.data.duLieu.thangNam ? dayjs(res.data.duLieu.thangNam) : null,
                    ngayNhanVien: res.data.duLieu.ngayNhanVien ? dayjs(res.data.duLieu.ngayNhanVien) : null,
                    ngayLanhDaoPhong: res.data.duLieu.ngayLanhDaoPhong ? dayjs(res.data.duLieu.ngayLanhDaoPhong) : null,
                    ngayBanDieuHanh: res.data.duLieu.ngayBanDieuHanh ? dayjs(res.data.duLieu.ngayBanDieuHanh) : null,
                };
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const xoaCauHinhHanChotKPI = async (id: number) => {
    await intance.post(ApiPaths.setting.xoaCauHinhHanChotKPI + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

/// Lấy danh sách bộ đếm số hiệu văn bản
export const layDSSoHieuVanBan = async () => {
    var rs: Array<SoHieuVanBan> = [];
    await intance.get(ApiPaths.setting.layDSSoHieuVanBan)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu.map((_item: any) => {
                    return {
                        id: _item.id,
                        loaiVanBan: _item.loaiVanBan,
                        tenLoaiVanBan: _item.tenLoaiVanBan,
                        nam: _item.nam,
                        maVanBan: _item.maVanBan,
                        soHienTai: _item.soHienTai,
                        doDaiSo: _item.doDaiSo,
                        soHieuGanNhat: _item.soHieuGanNhat || "",
                        soHieuTiepTheo: _item.soHieuTiepTheo || "",
                        soVanBanDaCap: _item.soVanBanDaCap,
                        soLonNhatDaDung: _item.soLonNhatDaDung,
                        ngayCapNhat: _item.ngayCapNhat ? dayjs(_item.ngayCapNhat) : null,
                    }
                });
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

/// Thêm mới hoặc cập nhật bộ đếm số hiệu văn bản của một năm
export const luuSoHieuVanBan = async (request: SoHieuVanBanRequest) => {
    await intance.post(ApiPaths.setting.luuSoHieuVanBan, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

/// Xoá bộ đếm số hiệu văn bản chưa cấp số nào
export const xoaSoHieuVanBan = async (id: number) => {
    await intance.post(ApiPaths.setting.xoaSoHieuVanBan + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};
